import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import desktopAnimationData from '@gik/calendar/assets/calendar-empty-state/desktop.json';
import mobileAnimationData from '@gik/calendar/assets/calendar-empty-state/mobile.json';
import { Animation, HTMLParser } from '@gik/ui';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

export interface ICalendarEmptyViewProps {
  canEdit?: boolean;
  onAddEvent?(): void;
}

export default function CalendarEmptyView({ canEdit, onAddEvent }: ICalendarEmptyViewProps): React.ReactElement {
  const bem = bemBlock('inkind-calendar-empty-view');
  const { t } = useTranslation();
  const isMdDown = useBreakpoint(Breakpoint.MD_DOWN);

  function _renderOrganizerView() {
    return (
      <div onClick={onAddEvent}>
        <div className={bem('organizer')}>
          <Animation
            className={bem('animation')}
            data={isMdDown ? mobileAnimationData : desktopAnimationData}
            mode="looped"
            assetsPrepend={`${getAssetsUrl()}homepage/calendar/images/`}
          />

          <p className={bem('leadText')}>
            <HTMLParser rawHtml={t(translationKeys.OrganizerViewLeadText)} />
          </p>
        </div>
        <p>{t(translationKeys.OrganizerViewText)}</p>
        <footer className={bem('footer')}>{t(translationKeys.OrganizerViewFooter)}</footer>
      </div>
    );
  }

  function _renderNonOrganizerView() {
    return (
      <div>
        <img src={`${getAssetsUrl()}calendar/calendar-icon.png`} />
        <p>{t(translationKeys.NonOrganizerText1)}</p>
        <p>{t(translationKeys.NonOrganizerText2)}</p>
      </div>
    );
  }

  return <div className={bem()}>{canEdit ? _renderOrganizerView() : _renderNonOrganizerView()}</div>;
}
